export const ServerError = "Internal Server Error!";

export const SessionTimeout = "Your session has expired! Please log in again";
